import { Tags } from 'rbh-merchant-core';
import { CatState } from './cat-reducer';
import { CAT_ACTION_TYPE, CatActions } from './cat-type';

export const catCreators = {
  setCatState: <KeyName extends keyof CatState>(key: KeyName, value: CatState[KeyName])
    : CatActions => ({
      type: CAT_ACTION_TYPE.SET_CAT_STATE,
      payload: { key, value }
    }),
  callFoodCategory: (onFailureCallback: () => void, isAddCategoryPage: boolean, onSuccessCallback?: (tagMaster: Tags[]) => void) => ({
    type: CAT_ACTION_TYPE.CALL_FOOD_CATEGORY,
    payload: { onFailureCallback, isAddCategoryPage, onSuccessCallback }
  }),
};
